import type { Division, Fleet, FleetEntry } from './contracts.js';

export function fnv1a(value: string): number {
  let hash = 0x811c9dc5;
  for (const byte of new TextEncoder().encode(value)) { hash ^= byte; hash = Math.imul(hash, 0x01000193); }
  return hash >>> 0;
}
export function assignFleet(tripId: string, entries: readonly FleetEntry[]): FleetEntry {
  if (entries.length === 0) throw new Error('fleet entries must not be empty');
  const total = entries.reduce((sum, entry) => sum + entry.weight, 0), target = fnv1a(tripId) / 0x1_0000_0000 * total;
  let cumulative = 0;
  for (const entry of entries) { cumulative += entry.weight; if (cumulative > target) return entry; }
  return entries.at(-1)!;
}
export const inferredDivision = (route: string): Division => /^[1-7]X?$/.test(route) ? 'A' : /^(SI|SIR)$/.test(route) ? 'SIR' : 'B';
export function fleetEntriesFor(fleet: Fleet, routeId: string): readonly FleetEntry[] {
  const key = routeId.toUpperCase(), canonical = fleet.aliases[key] ?? key;
  return fleet.routes[canonical]?.entries ?? [fleet.defaults[inferredDivision(canonical)]];
}
export class FleetAssignments {
  private assignments = new Map<string, { revision: string; entry: FleetEntry }>();
  get(tripId: string, routeId: string, fleet: Fleet): FleetEntry {
    const existing = this.assignments.get(tripId); if (existing) return existing.entry;
    const entry = assignFleet(tripId, fleetEntriesFor(fleet, routeId)); this.assignments.set(tripId, { revision: fleet.revision, entry }); return entry;
  }
  retain(activeTripIds: ReadonlySet<string>): void { for (const id of this.assignments.keys()) if (!activeTripIds.has(id)) this.assignments.delete(id); }
}
